import CollectionList from "@/js/Shared/Collections/CollectionList";
import IdentitiesItem from "./IdentitiesItem";

export { IdentitiesCollectionList as default };

/**
* Items List Collection
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IdentitiesCollectionList extends CollectionList {
  /**
   * Default idenitiy index
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Number} index_id
   */
  default;

  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} index_id
   *
   * @return {void}
   */
  constructor(index_id = 'index') {
    super(index_id);
  }

  /**
   * Returns a clone of a given identity index
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Number} index identity index
   *
   * @return {IdentitiesItem}
   */
  getClone(index) {
    let clone    = new IdentitiesItem();
    let identity = this.get(index);

    return (identity)
      ? Object.assign(clone, identity)
      : clone;
  }

  /**
   * Returns the default idenity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {IdentitiesItem}
   */
  getDefault() {
    return this.index[this.default];
  }
}